import { useContext, useState, useEffect } from "react";
import AddMultipleOptionModal from "./AddMultipleOptionModal";
import { Language } from "../../../App";
import {
    Col,  
    Modal,
    ModalFooter,
    ModalHeader, 
    Row,
  } from "reactstrap";

const AddQuestionModal = ({ isOpen, toggle, getQuestions, existingQuestions = null }) => {
    const { lang } = useContext(Language);
  
    const initialQuestionsData = [
      {
        question: "",
        answers: [""],
      },
    ];

    const [questionsData, setQuestionsData] = useState(initialQuestionsData);
    const [optionsModal, setOptionsModal] = useState(false);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(null);
    const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  
    // Load existing questions or reset to initial when modal opens
    useEffect(() => {
      if (isOpen) {
        if (existingQuestions && existingQuestions.length > 0) {
          setQuestionsData(existingQuestions);
          setHasUnsavedChanges(false);
        } else {
          setQuestionsData(initialQuestionsData);
          setHasUnsavedChanges(false);
        }
      }
    }, [isOpen, existingQuestions]);

    const addQuestion = () => {
      const newQuestion = { question: "", answers: [""] };
      const updatedQuestionsData = [...questionsData];
      updatedQuestionsData.push(newQuestion);
      setQuestionsData(updatedQuestionsData);
      setHasUnsavedChanges(true);
    };
  
    const removeQuestion = (index) => {
      // // Don't allow removing if only one question remains
      // if (questionsData.length <= 1) {
      //   return;
      // }
      
      const updatedQuestionsData = [...questionsData];
      updatedQuestionsData.splice(index, 1);
      setQuestionsData(updatedQuestionsData);
      setHasUnsavedChanges(true);
    };
  
    const saveAllQuestions = () => {
      const validQuestions = questionsData.filter(q => q.question.trim() !== "");
      const numberOfQuestions = validQuestions.length;
      getQuestions(validQuestions, numberOfQuestions);
      setHasUnsavedChanges(false);
      toggle();
    };

    const handleCancel = () => {
      // If there are unsaved changes and existing questions, revert to existing questions
      if (hasUnsavedChanges && existingQuestions && existingQuestions.length > 0) {
        setQuestionsData(existingQuestions);
      } else if (hasUnsavedChanges) {
        // If no existing questions, reset to initial state
        setQuestionsData(initialQuestionsData);
      }
      
      setHasUnsavedChanges(false);
      setOptionsModal(false);
      setCurrentQuestionIndex(null);
      toggle();
    };
  
    // Function to update the options count for the current question
    const updateOptionsCount = (index, count, optionsData) => {
      setQuestionsData((prev) =>
        prev.map((question, i) =>
          i === index ? { ...question, optionsCount: count, answers: optionsData } : question
        )
      );
      setHasUnsavedChanges(true);
    };
  
    return (
      <>
        <Modal isOpen={isOpen} centered size="lg">
          <ModalHeader toggle={handleCancel}>{lang.add_questions}</ModalHeader>
          <div className="p-3">
            {questionsData &&
              questionsData.map((value, index) => (
                <Row key={index}>
                  <Col>
                    <Row>
                      <Col>
                        <label className="pb-1 fs-15 roboto-medium">
                          {lang?.question + " " + (index + 1)}
                        </label>
                      </Col>
                      <Col className="text-end">
                        <label
                          className="pb-1 fs-15 roboto-medium text-blue cursor"
                          onClick={() => {
                            setCurrentQuestionIndex(index);
                            setOptionsModal(true);
                          }}
                        >
                          {lang?.add_multiple_option}{" "}
                          <span style={{ opacity: "0.3" }} className="text-dark">
                            {lang.opti}
                          </span>
                        </label>
                        <div>
                          {value.optionsCount > 0 &&
                            `(${value.optionsCount} options added)`}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <input
                          type="text"
                          className="py-2 form-control"
                          placeholder={lang.question}
                          value={value.question}
                          onChange={(e) => {
                            setQuestionsData((prev) =>
                              prev.map((question, i) =>
                                i === index
                                  ? { ...question, question: e.target.value }
                                  : question
                              )
                            );
                            setHasUnsavedChanges(true);
                          }}
                        />
                      </Col>
  
                      <Col md={1} className="align-self-center">
                        <button
                          className={`rounded border-0 fw-bold px-2 ${
                            questionsData.length <= 1 
                              ? 'text-muted' 
                              : 'text-danger'
                          }`}
                          onClick={() => removeQuestion(index)}
                          style={{ 
                            cursor:'pointer'
                          }}
                        >
                          x
                        </button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ))}
            <Row className="mt-3">
              <Col className="text-end">
                <button
                  className="bg-white rounded text-black fw-bold px-4 py-1"
                  style={{ border: "1px solid #1DC1DD" }}
                  onClick={addQuestion}
                >
                  {lang?.add_question}
                </button>
              </Col>
            </Row>
          </div>
          <ModalFooter className="gap-3">
            <button className="btn btn-secondary px-5" onClick={handleCancel}>
              {lang?.cancel}
            </button>
            <button className="btn-blue border-0 py-2 px-5" onClick={saveAllQuestions}>
              {lang?.save}
            </button>
          </ModalFooter>
        </Modal>
  
        <AddMultipleOptionModal
          isOpen={optionsModal}
          toggle={() => setOptionsModal(!optionsModal)}
          saveOptions={(count, optionsData) => updateOptionsCount(currentQuestionIndex, count, optionsData)}
          onCancel={() => {
            setOptionsModal(false);
            setCurrentQuestionIndex(null);
          }}
        />
      </>
    );
  };

export default AddQuestionModal;